export default "__VITE_ASSET__Bb5L__Am__"